var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyerregistration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35.2123C27.9411 35.2123 36 27.3297 36 17.6061C36 7.88253 27.9411 0 18 0C8.05887 0 0 7.88253 0 17.6061C0 27.3297 8.05887 35.2123 18 35.2123Z",
    fill: "url(#paint0_linear_668_108532)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_108532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4688 9.625H11.4062C10.0763 9.625 9 10.7013 9 12.0312V22.9688C9 24.2987 10.0763 25.375 11.4062 25.375H17.1725C16.7 24.3775 16.4375 23.2662 16.4375 22.0938L16.4462 21.875H12.2812C11.9225 21.875 11.625 21.5775 11.625 21.2188C11.625 20.86 11.9225 20.5625 12.2812 20.5625H16.595C16.7 20.0288 16.8662 19.5125 17.0763 19.0312H12.2812C11.9225 19.0312 11.625 18.7338 11.625 18.375C11.625 18.0162 11.9225 17.7188 12.2812 17.7188H17.82C18.2137 17.15 18.695 16.6337 19.2287 16.1875H12.2812C11.9225 16.1875 11.625 15.89 11.625 15.5312C11.625 15.1725 11.9225 14.875 12.2812 14.875H20.5938C20.7775 14.875 20.935 14.945 21.0575 15.0675C21.9237 14.6913 22.8775 14.4725 23.875 14.4462V12.0312C23.875 10.7013 22.7987 9.625 21.4688 9.625Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 8.75H18.7562C18.4675 7.74375 17.54 7 16.4375 7C15.335 7 14.4075 7.74375 14.1187 8.75H13.1562C12.7975 8.75 12.5 9.0475 12.5 9.40625V11.1562C12.5 11.9963 13.1913 12.6875 14.0312 12.6875H18.8438C19.6838 12.6875 20.375 11.9963 20.375 11.1562V9.40625C20.375 9.0475 20.0775 8.75 19.7188 8.75Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0575 15.0675C20.3925 15.3563 19.78 15.7334 19.2288 16.1875H12.2813C11.9225 16.1875 11.625 15.89 11.625 15.5312C11.625 15.1725 11.9225 14.875 12.2813 14.875H20.5938C20.7775 14.875 20.935 14.945 21.0575 15.0675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.82 17.7188C17.5313 18.13 17.2775 18.5675 17.0763 19.0312H12.2813C11.9225 19.0312 11.625 18.7337 11.625 18.375C11.625 18.0163 11.9225 17.7188 12.2813 17.7188H17.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.595 20.5625C16.5075 20.9913 16.455 21.4288 16.4462 21.875H12.2812C11.9225 21.875 11.625 21.5775 11.625 21.2188C11.625 20.86 11.9225 20.5625 12.2812 20.5625H16.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.625H11.4062C10.0763 9.625 9 10.7013 9 12.0312V22.9688C9 24.2987 10.0763 25.375 11.4062 25.375H16.4375V22.0938V21.875H12.2812C11.9225 21.875 11.625 21.5775 11.625 21.2188C11.625 20.86 11.9225 20.5625 12.2812 20.5625H16.4375V19.0312H12.2812C11.9225 19.0312 11.625 18.7338 11.625 18.375C11.625 18.0162 11.9225 17.7188 12.2812 17.7188H16.4375V16.1875H12.2812C11.9225 16.1875 11.625 15.89 11.625 15.5312C11.625 15.1725 11.9225 14.875 12.2812 14.875H16.4375V12.6875H14.0312C13.1912 12.6875 12.5 11.9962 12.5 11.1562V9.625Z",
    fill: "#1D83D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 7C15.335 7 14.4075 7.74375 14.1187 8.75H13.1562C12.7975 8.75 12.5 9.0475 12.5 9.40625V9.625V11.1562C12.5 11.9963 13.1913 12.6875 14.0312 12.6875H16.4375V7Z",
    fill: "url(#paint1_linear_668_108532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 14.875H12.2813C11.9225 14.875 11.625 15.1725 11.625 15.5312C11.625 15.89 11.9225 16.1875 12.2813 16.1875H16.4375V14.875Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 17.7188H12.2813C11.9225 17.7188 11.625 18.0163 11.625 18.375C11.625 18.7337 11.9225 19.0312 12.2813 19.0312H16.4375V17.7188Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 20.5625H12.2813C11.9225 20.5625 11.625 20.86 11.625 21.2188C11.625 21.5775 11.9225 21.875 12.2813 21.875H16.4375V20.5625Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0938 28C20.837 28 18.1875 25.3514 18.1875 22.0938C18.1875 18.8361 20.837 16.1875 24.0938 16.1875C27.3505 16.1875 30 18.8361 30 22.0938C30 25.3514 27.3505 28 24.0938 28Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.219 24.7189C22.9871 24.7189 22.7648 24.6261 22.6003 24.4625L20.8503 22.7125C20.5082 22.3704 20.5082 21.8174 20.8503 21.4753C21.1925 21.1331 21.7455 21.1331 22.0876 21.4753L23.1761 22.5638L25.6226 19.7681C25.9411 19.4059 26.4932 19.3674 26.8572 19.6859C27.2212 20.0035 27.2571 20.5556 26.9395 20.9196L23.877 24.4196C23.7177 24.6025 23.4902 24.7101 23.2478 24.7189H23.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0938 16.1875C20.837 16.1875 18.1875 18.8361 18.1875 22.0938C18.1875 25.3514 20.837 28 24.0938 28V24.1719L23.8768 24.4195C23.7175 24.6024 23.49 24.71 23.2476 24.7188H23.2188C22.9869 24.7188 22.7646 24.626 22.6001 24.4624L20.8501 22.7124C20.508 22.3703 20.508 21.8172 20.8501 21.4751C21.0208 21.3045 21.2448 21.2188 21.4688 21.2188C21.6927 21.2188 21.9167 21.3045 22.0874 21.4751L23.1759 22.5636L24.0938 21.5145V16.1875Z",
    fill: "#429846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.469 21.2188C21.245 21.2188 21.021 21.3045 20.8503 21.4751C20.5082 21.8172 20.5082 22.3703 20.8503 22.7124L22.6003 24.4624C22.7648 24.6269 22.9871 24.7188 23.219 24.7188H23.2478C23.4902 24.71 23.7177 24.6024 23.877 24.4195L24.094 24.1719V21.5145L23.1761 22.5636L22.0876 21.4751C21.917 21.3045 21.693 21.2188 21.469 21.2188Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_108532",
    x1: 18,
    y1: 35.2123,
    x2: 18,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_108532",
    x1: 14.4688,
    y1: 7,
    x2: 14.4688,
    y2: 12.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F74EE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_108532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerregistration);
export default __webpack_public_path__ + "static/media/buyerregistration.5fb79c193ec4a3c881b2356cfbd26615.svg";
export { ForwardRef as ReactComponent };